import { Accordion, Badge, Text } from "@zapier/design-system";
import { type LinkedAsset } from "./LinkedAssetsWarning";
import { LinkedAssetRows } from "./LinkedAssetRows";
import styles from "./LinkedAssetsAccordion.module.css";

interface LinkedAssetsAccordionProps {
  label: string;
  linkedAssets: LinkedAsset[];
  isInitiallyOpen?: boolean;
}

function AccordionTitle({ label, count }: { label: string; count: number }) {
  return (
    <span className={styles.accordionTitle}>
      <Text type="Body3" tag="span">
        {label}
      </Text>
      <Badge variant="neutral">{String(count)}</Badge>
    </span>
  );
}

/**
 * Bordered accordion box with a title + count badge header, wrapping
 * `LinkedAssetRows`. Shared by the connected-assets and can't-delete
 * sections of the delete modals.
 */
export function LinkedAssetsAccordion({
  label,
  linkedAssets,
  isInitiallyOpen = false,
}: LinkedAssetsAccordionProps) {
  return (
    <div className={styles.accordionBox}>
      <Accordion
        title={<AccordionTitle label={label} count={linkedAssets.length} />}
        isInitiallyOpen={isInitiallyOpen}
        toggleSide="left"
      >
        <LinkedAssetRows linkedAssets={linkedAssets} />
      </Accordion>
    </div>
  );
}
